module.exports = {
      id: "question-usage",
      viewBox: "0 0 29 29",
      url: __webpack_public_path__ + "sprite-99dfb162d59834e1e55e619b64a45f56.svg#question",
      toString: function () {
        return this.url;
      }
    }